export default __webpack_public_path__ + "static/media/gold-platedbangles.96b0bcf9.jpg";